import FacebookTrackingService from '@/services/tracking/FacebookTrackingService';
import DatalayerService from '@/services/tracking/DatalayerService';
export const facebookTrackingService = new FacebookTrackingService();
export const datalayerService = new DatalayerService();
